import React from 'react';
import styles from './KeyCompetitors.module.scss';
import { organisationIcon } from '../../../../../../assets/hostedassets';
import A4Page from '../../../../../AicaPDFReport/A4Page/A4Page';
import clsx from 'clsx';
import { reportSectionsToShow } from '../../../../../AicaPDFReport/AicaPDFReport';
import { REPORT_SECTION_NAMES } from '../../../../../../store/pdfReport/pdfReport_constants';
import orgIcon from './orgIcon.svg';
import AIGeneratedBadge from '../../../../../../common/AIGeneratedBadge/AIGeneratedBadge';
import HeaderBodyBox from '../../../../../../common/HeaderBodyBox';

interface KeyCompetitorsProps {
    competitorsInfo;
    isPDFReport: boolean;
}

const KeyCompetitors: React.FC<KeyCompetitorsProps> = ({ competitorsInfo, isPDFReport = false }) => {
    if (!competitorsInfo?.competitors?.length) return <></>;

    const renderCompetitorsList = () => (
        <div className={styles.tableContainer}>
            <div className={clsx(styles.Container)}>
                {competitorsInfo?.competitors.map((competitor, i) => (
                    <div className={styles.Card} key={i}>
                        <div className={styles.Image}>
                            <img
                                src={isPDFReport ? orgIcon : competitor?.imageUrl || orgIcon}
                                alt="logo"
                                width="100%"
                                onError={({ currentTarget }) => {
                                    currentTarget.onerror = null; // prevents looping
                                    currentTarget.src = orgIcon;
                                }}
                            />
                        </div>

                        <div className={styles.Title}>{competitor.displayName ?? competitor.name ?? '-'}</div>

                        <div className={styles.Text}>{competitor?.description}</div>
                    </div>
                ))}
            </div>
        </div>
    );

    const render = (
        <HeaderBodyBox
            title="Key Competitors"
            headerRight={<AIGeneratedBadge />}
            isPDFReport={isPDFReport}
            className={clsx(styles.competitorsContainer, { [styles.PDFReport]: isPDFReport })}
            bodyClassName={styles.competitorsBody}
        >
            {renderCompetitorsList()}
        </HeaderBodyBox>
    );

    if (isPDFReport)
        return competitorsInfo?.competitors.length && reportSectionsToShow.includes(REPORT_SECTION_NAMES.KEY_COMPETITORS) ? (
            <A4Page sectionName={REPORT_SECTION_NAMES.KEY_COMPETITORS}>{render}</A4Page>
        ) : (
            <></>
        );
    else return render;
};

export default KeyCompetitors;
